import MuiButton from '@mui/material/Button';
import PropTypes from 'prop-types';

import './style.scss';

const Button = ({
  id,
  txt,
  handleClick,
  variant,
  disable,
  className,
  isGreen
}) => {
  return (
    <MuiButton
      id={id || 'button-id'}
      classes={{ root: 'submit-btn' }}
      className={className}
      disabled={disable}
      variant={variant}
      style={{
        backgroundColor: isGreen
          ? 'inherit'
          : disable
          ? 'rgba(0, 0, 0, 0.26)'
          : '#003087',
        fontSize: isGreen ? '18px' : '10px',
        fontWeight: isGreen ? '700' : '400'
      }}
      disableElevation
      onClick={handleClick}
    >
      {txt || 'שמור'}
    </MuiButton>
  );
};

export default Button;

Button.propTypes = {
  id: PropTypes.string,
  txt: PropTypes.string,
  handleClick: PropTypes.func,
  variant: PropTypes.string,
  disable: PropTypes.bool,
  className: PropTypes.object,
  isGreen: PropTypes.bool
};
